<div class="flex h-full flex-col overflow-hidden" data-cy="kala-portfolio">
	@if (loading() && assets().length === 0) {
		<div class="flex grow items-center justify-center" data-cy="portfolio-loading">
			<ui-loading message="درحال بارگذاری ..." />
		</div>
	} @else if (error()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="portfolio-error"
			variant="error"
			iconName="alert-box"
			title="خطایی رخ داد!"
			primaryButtonLabel="تلاش مجدد"
			[showDescription]="false"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else if (showEmptyState()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="portfolio-empty"
			variant="empty"
			iconName="portfolio-error"
			title="پرتفوی شما خالیست!"
			primaryButtonLabel="جست‌وجو و خرید گواهی سپرده کالایی"
			[showDescription]="false"
			[showButton]="true"
			(primaryClicked)="onBrowseMarket()" />
	} @else {
		<div
			class="flex shrink-0 justify-center px-3 py-2 shadow-sm bg-gray-000"
			[class.rounded-b-2xl]="activeTab() === 'report'">
			<ui-tab
				size="sm"
				model="outline"
				ariaLabel="بخش‌های پرتفوی"
				[tabs]="tabs"
				[(activeTab)]="activeTab"
				(tabChanged)="onTabChanged($event)" />
		</div>

		@if (activeTab() === 'report') {
			<section
				role="tabpanel"
				tabindex="0"
				aria-label="گزارش پرتفوی"
				class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto pb-3"
				data-cy="portfolio-report">
				@if (depositBalanceLoading() && !depositBalanceLoaded()) {
					<div class="flex flex-1 items-center justify-center" data-cy="portfolio-report-loading">
						<ui-loading message="درحال بارگذاری ..." />
					</div>
				} @else if (depositBalanceError() && !depositBalanceLoaded()) {
					<ui-empty-state
						class="flex-1 items-center"
						data-cy="portfolio-report-error"
						variant="error"
						iconName="alert-box"
						title="خطایی رخ داد!"
						primaryButtonLabel="تلاش مجدد"
						[showDescription]="false"
						[showButton]="true"
						(primaryClicked)="onReportRetry()" />
				} @else {
					@if (depositBalanceError()) {
						<p class="text-sm text-red-500" role="alert">{{ depositBalanceError() }}</p>
					}

					<app-portfolio-composition
						[composition]="portfolioComposition()"
						[amountsHidden]="amountsHidden()"
						[maskedValue]="maskedValue" />
				}
			</section>
		} @else {
			<app-portfolio-summary
				[totalAssets]="totalAssets()"
				[totalNetSaleValue]="totalNetSaleValue()"
				[totalProfitLoss]="totalProfitLoss()"
				[totalProfitLossPercent]="totalProfitLossPercent()"
				[todayProfitLoss]="todayProfitLoss()" />

			<!-- Tapping anywhere on the column header opens the sort sheet. -->
			<button
				type="button"
				class="flex w-full cursor-pointer items-center gap-1 px-3 py-2 text-start font-medium"
				data-cy="portfolio-column-header"
				[attr.aria-label]="sortSummary()"
				(click)="onSortClick()">
				<div class="flex shrink-0 flex-col gap-0.5 text-2.75 text-gray-600">
					<span>آخرین قیمت</span>
					<span>سر به سر</span>
				</div>

				<div class="flex min-w-0 flex-1 flex-col items-end gap-0.5 text-2.75 text-gray-600">
					<span
						class="flex items-center"
						[class.text-gray-900]="headerSort().column === 'netSaleValue'"
						[class.font-bold]="headerSort().column === 'netSaleValue'">
						<span>ارزش فعلی</span>
						@if (headerSort().column !== 'profitLoss') {
							<ui-icon width="20" height="20" aria-hidden="true" [iconName]="headerSort().icon" />
						}
					</span>

					<span
						class="flex items-center"
						[class.text-gray-900]="headerSort().column === 'profitLoss'"
						[class.font-bold]="headerSort().column === 'profitLoss'">
						<span>سود زیان فعلی</span>
						@if (headerSort().column === 'profitLoss') {
							<ui-icon width="20" height="20" aria-hidden="true" [iconName]="headerSort().icon" />
						}
					</span>
				</div>
			</button>

			<app-portfolio-sort-bottom-sheet
				#sortSheet
				[criterion]="sortCriterion()"
				[direction]="sortDirection()"
				(sortChanged)="onSortChanged($event)" />

			<div
				#assetList
				swipeRightLeft
				swipeSide="Left"
				swipeWidth="156"
				class="flex min-h-0 w-full flex-1 flex-col gap-1 overflow-y-auto pb-3"
				(scroll)="onListScroll($event)">
				@for (asset of sortedAssets(); track asset.contractId) {
					<app-portfolio-card-item
						[asset]="asset"
						[amountsHidden]="amountsHidden()"
						(detailRequested)="onDetailRequested($event)" />
				}
			</div>
		}
	}

	<!-- The menu and its settings sheet sit outside the branches above: the
		header's three-dot button is present whatever the list is showing, so the
		sheets it opens have to be rendered in every state. -->
	<app-portfolio-menu-bottom-sheet
		#menuSheet
		(settingsSelected)="onSettingsSelected()"
		(riskStatementSelected)="onRiskStatementSelected()" />
	<app-portfolio-settings-bottom-sheet #settingsSheet />
	<app-portfolio-risk-statement-bottom-sheet #riskStatementSheet />
</div>
